module.exports = __webpack_public_path__ + "img/hall_of_honor_small.85498545.png";